import React from 'react';
import ContentLoader from 'react-content-loader';

const PLACEHOLDER_UNIT = 10;
export const PricePlaceholder: React.FC<{ uniqueKey: string; widthRatio: number }> = ({
  uniqueKey,
  widthRatio,
}) => {
  const height = PLACEHOLDER_UNIT;
  const width = widthRatio * PLACEHOLDER_UNIT;
  return (
    <ContentLoader
      width={`${widthRatio}em`}
      style={{ display: 'inline', verticalAlign: 'middle' }}
      height="1em"
      foregroundColor="#f3f3f3"
      backgroundColor="var(--Grey-Accent-Color)"
      speed={3}
      uniqueKey={uniqueKey}
      viewBox={`0 0 ${width} ${height}`}
    >
      <rect x={0} y={0} rx={2} ry={2} height={height} width={width} />
    </ContentLoader>
  );
};
